import React from "react";
import "./RoofingTab.css";
import Option from "src/components/Input/Option/Option";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import RadioBlocks from "src/components/Input/RadioBlocks/RadioBlocks";
import SelectUnselectExtended from "src/components/Input/SelectUnselectExtended/SelectUnselectExtended";
import RadioBlocksExtended from "src/components/Input/RadioBlocksExtended/RadioBlocksExtended";
import { isFlatRoofType } from "src/helpers/roofType";

const roofingDataPlatdak = [
  {
    id: 1,
    name: "EPDM + lijm",
    imageUrl: "./images/edpm.png",
    description:
      "Als meest geschikte dakbedekking adviseren wij om EPDM dakbedekking toe te voegen aan uw bestelling. EPDM is en elastische dakbedekking en ideaal geschikt voor alle weersomstandigheden. Voor de perfecte afwerking van uw dak kunnen wij de afwerking met een aluminium daktrim aanbevelen.",
  },
];

const roofingDataKapschuur = [
  {
    id: 1,
    name: "Geen Dakbedekking",
    imageUrl: `${process.env.PUBLIC_URL}/images/empty.svg`,
    color: "",
    value: "empty",
    price: 0,
    description: "",
  },
  {
    id: 1,
    name: "Dakplaten Zwart (incl. tengels, folie, panlatten en nokvorsten)",
    imageUrl: `${process.env.PUBLIC_URL}/images/dakpanplaat zwart.jpg`,
    color: "",
    value: "dakpanplaat",
    price: 0,
    description: "",
  },
  {
    id: 2,
    name: "Dakplaten Terracotta (incl. tengels, folie, panlatten en nokvorsten)",
    imageUrl: `${process.env.PUBLIC_URL}/images/dakpanplaat terracotta.jpg`,
    color: "",
    value: "dakpanplaat_rood",
    price: 0,
    description: "",
  },
  {
    id: 3,
    name: "Shingles Zwart",
    imageUrl: `${process.env.PUBLIC_URL}/images/dakshingles_zwart.jpg`,
    color: "",
    value: "leiendak",
    price: 0,
    description: "",
  },
  {
    id: 4,
    name: "Shingles Groen",
    imageUrl: `${process.env.PUBLIC_URL}/images/dakshingles_groen.jpg`,
    color: "",
    value: "leiendak_green",
    price: 0,
    description: "",
  },
  {
    id: 5,
    name: "Shingles Rood",
    imageUrl: `${process.env.PUBLIC_URL}/images/dakshingles_rood.jpg`,
    color: "",
    value: "leiendak_red",
    price: 0,
    description: "",
  },
];

const gutterData = [
  {
    id: 1,
    name: "Zink",
    imageUrl: `${process.env.PUBLIC_URL}/images/gutter-1.png`,
    color: "",
    value: "zink",
    price: 0,
    description: "",
  },
  {
    id: 2,
    name: "Kunststof",
    imageUrl: `${process.env.PUBLIC_URL}/images/gutter-2.png`,
    color: "",
    value: "zink_black",
    price: 0,
    description: "",
  },
];

const RoofingTab: React.FC = () => {
  const { state, setRoof, setGutter } = useConfiguration();
  const { calculation } = useConfiguration();

  const roofingData = roofingDataKapschuur.map((item) => {
    return { ...item, price: calculation.getRoofingPrice(item.value) };
  });

  const handleEpdmGlue = (epdmGlueEnable: boolean) => {
    if (state.roof.epdmGlue !== epdmGlueEnable) {
      setRoof({ ...state.roof, epdmGlue: epdmGlueEnable });
    }
  };

  const handleRoofType = (roofType: string) => {
    setRoof({ ...state.roof, type: roofType });
  };
  return (
    <div className="roofing-tab">
      {isFlatRoofType(state.roofType) &&
        roofingDataPlatdak.map((item) => {
          return (
            // <Option
            //   key={"epdm-glue-enable"}
            //   className={"epdm-glue-option"}
            //   image={item.imageUrl}
            //   name={item.name}
            //   description={item.description}
            //   components={[]}
            //   value={state.roof.epdmGlue}
            //   onChange={handleEpdmGlue}
            //   price={calculation.getEPDMGlue()}
            // />

            <SelectUnselectExtended
              key={"epdm-glue-enable"}
              // className={"epdm-glue-option"}
              imageUrl={item.imageUrl}
              name={item.name}
              description={item.description}
              isSelected={state.roof.epdmGlue}
              onSelect={() => handleEpdmGlue(true)}
              onUnselect={() => handleEpdmGlue(false)}
              price={Math.round(calculation.getEPDMGlue())}
            />
          );
        })}
      {state.roofType === "kapschuur" && (
        <>
          <RadioBlocksExtended
            blocks={roofingData}
            value={state.roof.type}
            onChange={handleRoofType}
          />
        </>
      )}
    </div>
  );
};

export default RoofingTab;
